import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { useAuth } from "./auth";

const DEFAULTS = {
  pharmacyEnabled: true,
  chatEnabled: true,
  supportEnabled: true,
  aiEnabled: true,
  pharmacyEnabledAt: null,
};

const SettingsCtx = createContext({ ...DEFAULTS, reload: () => {}, applyFlags: () => {} });

const fromApi = (d) => ({
  pharmacyEnabled: !!d.pharmacy_enabled,
  chatEnabled: !!d.chat_enabled,
  supportEnabled: !!d.support_enabled,
  aiEnabled: !!d.ai_enabled,
  pharmacyEnabledAt: d.pharmacy_enabled_at || null,
});

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [flags, setFlags] = useState(DEFAULTS);

  const reload = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/settings/public");
      setFlags(fromApi(data));
    } catch {
      /* keep defaults */
    }
  }, [user]);

  // Optimistic update used by admin toggles
  const applyFlags = useCallback((apiResponse) => {
    setFlags(fromApi(apiResponse));
  }, []);

  useEffect(() => {
    reload();
    if (!user) return;
    const t = setInterval(reload, 30000);
    return () => clearInterval(t);
  }, [user, reload]);

  return (
    <SettingsCtx.Provider value={{ ...flags, reload, applyFlags }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
